module.exports = __webpack_public_path__ + "img/select.116fb2b3.svg";